import { config } from "../env";
import { get, getBlob, post, postFileUpload } from "./helpers/http-handler";


export const mediaUpload = (payload: object) =>
  postFileUpload(`${config.API_URL}/media-uploads/file/upload`, payload);

export const mediaPublicUpload = (payload: object) =>
  postFileUpload(`${config.API_URL}/media-uploads/file/upload/public`, payload);

export const mediaUploadGenratePresignedURL = (payload: object) =>
  post(`${config.API_URL}/media-uploads/generate-presinged-url`, payload);

export const mediaUploadCreateS3DirectUpload = (payload: object) =>
  post(`${config.API_URL}/media-uploads/create-s3-direct-upload`, payload);

export const adminReportsDownload = (payload: object) =>
  post(`${config.API_URL}/reports/expense-report`, payload);

export const adminTripsDownload = (payload: object) =>
  post(`${config.API_URL}/reports/trip`, payload);

export const adminReportsDownloadExpenses = (payload: object) =>
  post(`${config.API_URL}/reports/expense-report-expense`, payload);

export const adminReportsDownloadExpensesSummary = (queryRequest: string) =>
  getBlob(`${config.API_URL}/expense-entry/export/expense-details?${queryRequest}`);

export const adminReportsDownloadApprovedExpenseCategoryDepartment = (
  queryRequest: string,
) =>
  getBlob(
    `${config.API_URL}/expense-entry/export/approved-expense-category-department?${queryRequest}`,
  );

export const adminReportAttachmentsDownloadExpenses = (payload: object) =>
  post(`${config.API_URL}/reports/expense-report-expense-attachments`, payload);

export const adminReportAttachmentsDownloadExpenseReport = (payload: object) =>
  post(`${config.API_URL}/reports/expense-report-attachments`, payload);

export const adminReportAttachmentsDownloadTrip = (payload: object) =>
  post(`${config.API_URL}/reports/trip-attachments`, payload);
